<template>
  <div class="guide-ul">
    <div v-if="guide.length > 0">
      <div :class="['guide-li', active != '' ? 'guide-li-two' : '']" v-for="(item, index) in guide" :key="index" @click="onClickRoute(item)">
        <div class="guide-left">
          <p>{{ item.title }}</p>
        </div>
        <div class="guide-right">
          {{ showTime(item.createTime, 'day', '-') }}
        </div>
      </div>
    </div>
    <empty class="empty-margin" v-if="guide.length <= 0"></empty>
    <el-pagination v-if="active != ''" class="paging" background :current-page="page.number" :page-sizes="[10, 20, 30, 40]" :page-size="page.limit" layout="prev, pager, next, sizes" :total="page.total"
      @size-change="sizeChange" @current-change="currentChange" @prev-click="prevClick" @next-click="nextClick" />
  </div>
</template>

<script>
import { getTime } from "@/util/public";
import empty from "@/components/empty/index";
export default {
  name: "index",
  components: { empty },
  props: {
    // 定义 guide 为数组类型，必填
    guide: {
      type: Array,
      required: true,
      default: () => [] // 防止 undefined
    },
    page: {
      type: Object,
      default: () => {
        return {
          number: 1,
          limit: 10,
          total: 0,
        }
      }
    },
    active: {
      type: String,
      default: ""
    },
    pageRoute: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      appPage: {
        COURSE: 'CourseDetails',
        SCIENCE: 'NewsDetailsTwo',
        GUIDE_CONSENSUS: 'NewsDetailsThree',
        NOTICE: 'QualityControlDetails',
      }
    };
  },
  methods: {
    onClickRoute(value) {
      let token = localStorage.getItem("x-token")
      if(token == null) {
        this.$router.push({ path: `/codeLogin` });
        return
      }
      this.$router.push({ path: `/${this.appPage[this.active ? this.active : this.pageRoute]}/${value.id}` });
    },
    showTime(value, type, separation) {
      return getTime(value, type, separation)
    },
    sizeChange(value) {
      this.$emit('sizeChange', value)
    },
    currentChange(value) {
      this.$emit('currentChange', value)
    },
    prevClick(value) {
      this.$emit('currentChange', value)
    },
    nextClick(value) {
      this.$emit('currentChange', value)
    },
  },
  mounted() {

  }
};
</script>

<style scoped lang="less">
.guide-ul {
  margin-top: 20px;

  .guide-li-two {
    border-bottom: 1px dashed #00000033;
    min-height: 58px;
    margin-bottom: 0 !important;
  }

  .guide-li:last-child {
    margin-bottom: 0;
  }

  .guide-li:hover {
    .guide-left {
      color: #a41218;
    }
  }

  .guide-li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: normal;
    margin-bottom: 26px;
    cursor: pointer;

    .guide-left {
      padding-left: 2px;
      width: calc(100% - 100px);
      display: flex;
      align-items: center;
      font-size: 18px;
      color: rgba(38, 38, 38, 1);

      p {
        margin: 0;
        width: 100%;
        line-height: 24px;
        white-space: nowrap;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
      }
    }

    .guide-left:before {
      content: "";
      display: block;
      width: 8px;
      height: 8px;
      background: rgba(164, 18, 24, 1);
      transform: rotate(45deg);
      margin-right: 10px;
    }

    .guide-right {
      color: rgba(115, 115, 115, 1);
      font-size: 14px;
      line-height: 24px;
      width: 100px;
      text-align: right;
    }
  }
}

/deep/.el-input__inner {
  height: 32px;
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination button {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pager li {
  border: 1px solid var(---, rgba(0, 0, 0, 0.15)) !important;
  background: #fff !important;
  width: 32px;
  height: 32px;
  border-right: 2px;
  color: rgba(0, 0, 0, 0.45) !important;
  line-height: 30px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #BD181E !important;
  color: rgba(255, 255, 255, 0.65) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/guide/index.vue